import { Box, Button, Text } from '@quintoandar-tokko/jopijs';
import EmptyStateIcon from '@/public/images/dashboard/magnifying-glass.svg';
import ImageNext from '@/components/shared/ImageNext';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import styles from './dashboardTables.module.scss';

export default function TableSearchEmptyState({ onClearFilters }) {
  return (
    <Box className={styles.emptyStateContainer}>
      <ImageNext
        alt={Trans(translations, 'NoResultsFound')}
        src={EmptyStateIcon}
        height={88}
        width={88}
      />
      <Text className={styles.emptyStateTitle}>
        {Trans(translations, 'NoResultsFound')}
      </Text>
      <Text className={styles.emptyStateSubtitle}>
        {Trans(translations, 'TryAdjustingYourWordsToFindWhatYouAreLookingFor')}
      </Text>
      <Button
        variant={['primary', 'medium']}
        className={styles.emptyStateButton}
        onClick={onClearFilters}
      >
        {Trans(translations, 'ClearFilters')}
      </Button>
    </Box>
  );
}
